export class Route {
  name: string;
  url: string;
  templateUrl: string;
  parent: string;
  params?: any;
}

export const routing: Route[] = [
  {
    name: 'app',
    url: '/app',
    templateUrl: require('./Components/app/app.html'),
    parent: undefined,
  },
  {
    name: 'login',
    url: '/login',
    templateUrl: require('./Components/login/login.html'),
    parent: 'app',
  },
  {
    name: 'person-home',
    url: '/person-home',
    templateUrl: require('./Components/person-home/person-home.html'),
    parent: 'app',
  },
  {
    name: 'terminal-home',
    url: '/terminal-home',
    templateUrl: require('./Components/terminal-home/terminal-home.html'),
    parent: 'app',
  },
  {
    name: 'settings',
    url: '/settings',
    templateUrl: require('./Components/settings/settings.html'),
    parent: 'app',
    params: { forced: false },
  },
  {
    name: 'debug',
    url: '/debug',
    templateUrl: require('./Components/debug/debug.html'),
    parent: 'app',
  },
  {
    name: 'expense-list',
    url: '/expense-list/:userId',
    templateUrl: require('./Components/expense-list/expense-list.html'),
    parent: 'app',
  },
  {
    name: 'expense-detail',
    url: '/expense-detail/:userId/:expenseId?',
    templateUrl: require('./Components/expense-detail/expense-detail.html'),
    parent: 'app',
  },
  {
    name: 'absence-list',
    url: '/absence-list/:userId',
    templateUrl: require('./Components/absence-list/absence-list.html'),
    parent: 'app',
  },
  {
    name: 'absence-detail',
    url: '/absence-detail/:userId/:absenceId?',
    templateUrl: require('./Components/absence-detail/absence-detail.html'),
    parent: 'app',
  },
  {
    name: 'booking-list',
    url: '/booking-list/:userId',
    templateUrl: require('./Components/booking-list/booking-list.html'),
    parent: 'app',
  },
  {
    name: 'booking-detail',
    url: '/booking-detail/:userId/:bookingId?',
    templateUrl: require('./Components/booking-detail/booking-detail.html'),
    parent: 'app',
  },
  {
    name: 'enter',
    url: '/enter',
    templateUrl: require('./Components/enter/enter.html'),
    parent: 'app',
    params: {
      person: null,
      confirm: false
    }
  },
  {
    name: 'start',
    url: '/start',
    templateUrl: require('./Components/start/start.html'),
    parent: 'app',
    params: {
      person: null,
    }
  },
];

export const defaultRoute = '/app/login';
